<script>
  // 円グラフ
  import { Pie } from 'vue-chartjs'

  export default {
    extends: Pie,

    props: ['chartData'],

    mounted() {
      this.renderChart(this.chartData, {
        responsive: true,

        legend: {
          position: 'bottom'
        },

        tooltips: {
          callbacks: {
            label: function(tooltipItem, data) {
              const label = data.labels[tooltipItem.index]
              const value = data.datasets[0].data[tooltipItem.index]
              return label + ': ' + value + '人'
            }
          }
        }
      })
    }
  }
</script>